import { render } from "./Principal-approveRequest.vue?vue&type=template&id=783bfc1c"
import script from "./Principal-approveRequest.vue?vue&type=script&lang=js"
export * from "./Principal-approveRequest.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__